import { Api, RequestContext } from '../api';
import { BrowserFourdApi } from './desktop';
import { IframeWindow } from './web';
import { getQueryStringValue } from './util';

export class LeapHostSdkFactory {
  static getInstance(): Api {
    //we only support desktop and IFrame at the moment
    const requestContext = this.getRequestContext();
    if (!requestContext) return null;
    const newTab: boolean = (getQueryStringValue('newTab') || '').toLowerCase() === 'true';

    if (!!window['$4d'] || requestContext.host === 'desktop') return new BrowserFourdApi(requestContext);
    else return new IframeWindow(requestContext, newTab);
  }

  private static getRequestContext() {
    const appSessionId: string = getQueryStringValue('appSessionId');
    if (!appSessionId) return null;

    const host: string = getQueryStringValue('host') ?? 'desktop';
    let env: string = getQueryStringValue('env');
    const region: string = getQueryStringValue('region');
    const trustedApp: boolean = (getQueryStringValue('trustedApp') || '').toLowerCase() === 'true';

    //backward compatiable with v1 messageBus like "autest"
    if (!!env) {
      if (env.includes('liveb')) env = 'liveb';
      else if (env.includes('live')) env = 'live';
      else if (env.includes('test')) env = 'test';
      else if (env.includes('dev')) env = 'dev';
    }

    const requestContext: RequestContext = {
      appSessionId,
      host,
      env,
      region,
      trustedApp,
    };

    return requestContext;
  }
}

export { RequestContext, MatterBasedRequest, LeapContext, HostResponse, BaseRequest, Api } from '../api';
